export const formatPercentage = (value) => {
    if (value === null || value === undefined)
        return "-";
    if (typeof value === "number") {
        return `${value}%`;
    }
    return value;
};
export const formatGap = (value) => {
    if (value === null || value === undefined)
        return "-";
    if (typeof value === "number") {
        if (value > 0)
            return `+${value}`;
        return value.toString();
    }
    return value;
};
export const formatChangeValue = (value) => {
    if (value === null || value === undefined)
        return null;
    if (typeof value === "number") {
        if (!Number.isFinite(value))
            return null;
        return value;
    }
    const parsed = Number.parseFloat(value);
    if (!Number.isFinite(parsed))
        return null;
    return parsed;
};
